// extracted by mini-css-extract-plugin
module.exports = {"partnerModal":"PartnerModal_partnerModal__MlZ_d"};